import { createAsyncThunk } from "@reduxjs/toolkit";

import { getAppVersionApi, postAppVersionApi } from "@/apis/appVersionApi";

import {
  AppVersionType,
  GetAppVersionType,
} from "@/commonTypes/appVersionType";

export const postAppVersionAction = createAsyncThunk(
  "appVersion/postAppVersion",
  async (data: AppVersionType) => {
    const response = await postAppVersionApi(data);
    return response.data;
  }
);

export const getAppVersionAction = createAsyncThunk(
  "appVersion/getAppVersion",
  async (data: GetAppVersionType) => {
    const response = await getAppVersionApi(data);
    return response.data;
  }
);
